import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, emailRequired } = useAuth(); // Use the custom hook for better consistency
  const { customerId } = useParams(); // Extract customerId from the URL
  const location = useLocation();

  if (!user) {
    // Redirect to the dynamic login path if the user is not authenticated
    return <Navigate to={`/customer/${customerId}/login`} replace />;
  }

  // WEST-794: a user with no email on file may only visit their own profile until they add one.
  if (emailRequired) {
    const ownProfile = `/customer/${customerId}/user/manage/${user.id}`;
    if (location.pathname !== ownProfile) {
      return <Navigate to={ownProfile} replace />;
    }
  }

  // Render the children if the user is authenticated
  return children;
};

export default ProtectedRoute;
